import BackoffStrategy from "./BackoffStrategy.js";
// src/lib/ExponentialBackoffStrategy.ts
var ExponentialBackoffStrategy = class ExponentialBackoffStrategy extends BackoffStrategy {
	static DEFAULT_FACTOR = 2;
	backoffDelay_;
	nextBackoffDelay_;
	factor_;
	/**
	* The options are the following.
	*
	* @param options.randomisationFactor: defaults to 0, must be between 0 and 1
	* @param options.initialDelay: defaults to 100 ms
	* @param options.maxDelay: defaults to 10000 ms
	* @param options.factor: defaults to 2, must be greater than 1
	*/
	constructor(options = {}) {
		super(options);
		this.backoffDelay_ = 0;
		this.nextBackoffDelay_ = this.getInitialDelay();
		this.factor_ = ExponentialBackoffStrategy.DEFAULT_FACTOR;
		if (typeof options.factor === "number") {
			if (options.factor <= 1) throw new Error(`Exponential factor should be greater than 1 but got ${options.factor}.`);
			this.factor_ = options.factor;
		}
	}
	next_() {
		this.backoffDelay_ = Math.min(this.nextBackoffDelay_, this.getMaxDelay());
		this.nextBackoffDelay_ = this.backoffDelay_ * this.factor_;
		return this.backoffDelay_;
	}
	reset_() {
		this.backoffDelay_ = 0;
		this.nextBackoffDelay_ = this.getInitialDelay();
	}
};
export { ExponentialBackoffStrategy as default };

//# sourceMappingURL=ExponentialBackoffStrategy.js.map